module.exports = __webpack_public_path__ + "static/media/info-circle-solid.07e20cdb.svg";